// src/experiments/hash.js

// FNV-1a, 32-bit. Six lines, no dependencies, identical output in every JS
// engine, and fast enough to run a hundred thousand times inside a unit test.
// It is not a cryptographic hash and does not need to be: its only job is to
// spread `salt:key:uid` strings evenly over the bucket range, so an assignment
// can be recomputed from the uid alone instead of being stored anywhere.
export function fnv1a32(input) {
  const str = String(input);
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
}

// Assignment works in ten-thousandths: traffic 0.25 enrols gate buckets
// 0–2499, and a variant weight of 0.5 spans 5,000 buckets. Fine enough for
// 0.01% steps, coarse enough that the arithmetic stays exact.
export const BUCKETS = 10000;

export function bucket(input) {
  return fnv1a32(input) % BUCKETS;
}
